module.exports = __webpack_public_path__ + "img/新井先生photo_PF用.d3f4d15f.png";